import React from 'react';
import TaxonomyGrid from './TaxonomyGrid';
import { Container, ScrollableContainer } from './TaxonomyGrid.styles';

export default ({ company, ...props }) => {
	return (
		<Container>
			<ScrollableContainer>
				<TaxonomyGrid {...props} company={company} />
			</ScrollableContainer>
		</Container>
	);
};
